"use client";

import Image from "next/image";

export default function TopAbout() {
    return (
        <div className="relative w-full flex flex-col md:flex-row items-center justify-center h-[300px]">

            {/* content wrapper */}
            <div className="flex flex-col md:flex-row w-full px-6 md:px-20 lg:px-32 md:h-[300px] items-center justify-center md:absolute md:-top-10 gap-6 md:gap-0">

                {/* Mission */}
                <div className="flex w-full md:w-1/2 h-auto md:h-full bg-secondary rounded-xl md:rounded-none">
                    <div className="flex flex-col px-6 py-10 md:p-10 items-center justify-center gap-4 text-center">
                        <h3 className="text-white text-[30px] md:text-[38px] lg:text-[42px] font-bold font-lora">
                            Our <span className="text-primary">Mission</span>
                        </h3>
                        <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed max-w-[480px]">
                            To deliver exceptional legal services with integrity, precision, and dedication—empowering clients to achieve their goals while upholding justice and the rule of law.
                        </p>
                    </div>
                </div>

                {/* Vision */}
                <div className="flex w-full md:w-1/2 h-auto md:h-full bg-primary rounded-xl md:rounded-none">
                    <div className="flex flex-col px-6 py-10 md:p-10 items-center justify-center gap-4 text-center">
                        <h3 className="text-white text-[30px] md:text-[38px] lg:text-[42px] font-bold font-lora">
                            Our <span className="text-secondary">Vision</span>
                        </h3>
                        <p className="text-base md:text-lg lg:text-xl text-white leading-relaxed max-w-[480px]">
                            To be a trusted leader in legal practice, recognized for innovation, excellence, and lasting impact in the communities we serve.
                        </p>
                    </div>
                </div>

            </div>

        </div>
    );
}
